export default {
    status: {
        pending: 'Pending',
        paid: 'Paid',
        processing: 'Processing',
        packing: 'Packing',
        fulfilled: 'Shipped',
        readyForPickup: 'Ready for pickup',
        cancelled: 'Cancelled',
        refunded: 'Refunded',
    },
    shared: {
        order: 'Order',
        placed: 'Placed',
        customer: 'Customer',
        payment: 'Payment',
        sendAgain: 'Send again',
    },
    emailKind: {
        orderConfirmation: 'Order confirmation',
        shopNotification: 'New-order mail to the shop',
        statusProcessing: 'Status: processing',
        statusPacking: 'Status: packing',
        statusFulfilled: 'Status: shipped',
        statusReadyForPickup: 'Status: ready for pickup',
        invoice: 'Invoice',
        creditNote: 'Credit note',
        giftCard: 'Gift card',
        reviewRequest: 'Review request',
    },
    packingSlip: {
        tooMany: 'At most {max} orders can be printed at once.',
        failed: 'Packing slip failed (HTTP {status})',
    },
    list: {
        title: 'Orders',
        anyStatus: 'Any status',
        toShip: 'To ship',
        notifyCustomers: 'Email customers',
        packingSlips: 'Packing slips',
        search: 'Search by email…',
        empty: 'No orders match these filters.',
        clearSelection: 'Clear selection',
        selectAll: 'Select all on this page',
        selectOrder: 'Select order {number}',
        shipsOn: 'ships {date}',
        delivery: 'delivery {moment}',
        page: 'Page {page} of {pages}',
        count: 'no orders | {n} order | {n} orders',
        bulk: {
            noneMovable: 'None of the selected orders can move to {step}.',
            confirmEmail: 'Move {n} order to {step}? Customers are emailed, except bol.com orders. | Move {n} orders to {step}? Customers are emailed, except bol.com orders.',
            confirmNoEmail: 'Move {n} order to {step}? No customer is emailed. | Move {n} orders to {step}? No customer is emailed.',
            moved: '{n} moved to {step}',
            skipped: '{n} skipped',
            mailFailed: '{n} email not sent | {n} emails not sent',
            failed: 'failed: {ids}',
        },
    },
    edit: {
        title: 'Order {number}',
        cancelOrder: 'Cancel order',
        refund: 'Refund',
        confirmRefund: 'Mark this order as refunded? Refund the payment in the gateway dashboard separately.',
        refunded: 'Order marked refunded',
        paymentReceived: 'Payment received',
        confirmPaymentReceived: 'Record that the money for this order has come in?',
        paymentRecorded: 'Payment recorded',
        confirmCancel: 'Cancel this pending order? Reserved stock will be released.',
        cancelled: 'Order cancelled',
        deleteOrder: 'Delete order',
        confirmDelete: 'Delete this unpaid order for good? Its lines, payment history, emails and notes are removed too. This cannot be undone.',
        deleted: 'Order deleted',
        tabs: {
            order: 'Order',
            slip: 'Packing slip',
            invoice: 'Invoice',
            emails: 'Emails',
            emailsCount: 'Emails ({n})',
        },
        summary: {
            title: 'Summary',
            shipsFrom: 'Ships from',
            delivery: 'Delivery',
            paid: 'Paid',
            awaitingPayment: 'Not yet: paid on delivery',
            shipped: 'Shipped',
            readyForPickup: 'Ready for pickup',
            refunded: 'Refunded',
            guest: 'Guest: {email}',
        },
        steps: {
            title: 'Fulfilment',
            moveTo: 'Move to {step}',
            markReadyForPickup: 'Mark ready for pickup',
            markShipped: 'Mark shipped',
            notify: 'Email the customer when the order moves forward',
            bolNote: 'bol.com order: bol.com keeps the customer informed, so the shop does not email them.',
            trackingHint: "The tracking code under Shipment is saved with it and goes into the customer's email.",
            pickupHint: "Mark it when the order is ready to be collected: the customer's email says so, with the pickup address.",
            help: "The customer's email is in their own language. Picking an earlier step moves the order back and emails nobody. Every change is noted under Internal notes.",
            moved: 'Moved to {step}',
            movedEmailed: 'Moved to {step}; the customer was emailed',
            movedMailFailed: 'Moved to {step}, but the customer email could not be sent. See the note on the order.',
        },
        shipment: {
            title: 'Shipment',
            pickup: 'This order is a pickup, so there is nothing to track.',
            pickupAt: 'This order is a pickup at {location}, so there is nothing to track.',
            trackingCode: 'Tracking code',
            carrier: 'Carrier: {carrier}',
            noCarrier: 'No carrier recorded on this order; the code is stored but cannot be linked.',
            openTracking: 'Open track & trace',
            noLink: 'Saved. No lookup link: the carrier on this order is not one we know a tracking URL for.',
            saved: 'Tracking code saved',
        },
        items: {
            title: 'Items',
            product: 'Product',
            qty: 'Qty',
            unit: 'Unit',
            lineSubtotal: 'Line subtotal',
            lineTax: 'Line tax',
        },
        totals: {
            subtotal: 'Subtotal',
            discount: 'Discount',
            shipping: 'Shipping',
            tax: 'Tax',
            vatOf: 'of which VAT {country} {rate}',
            giftCard: 'Gift card',
            paid: 'Paid',
        },
        vat: {
            title: 'VAT',
            vies: 'VIES {result} for {number} on {date}',
            consultation: 'consultation {number}',
            notTaxed: 'The engine did not tax this order:',
            rate: 'Rate',
            base: 'Base',
            vat: 'VAT',
            viesResult: {
                valid: 'valid',
                invalid: 'invalid',
                unavailable: 'unavailable',
            },
            scheme: {
                domestic: 'Dutch VAT (domestic sale)',
                distanceSaleOrigin: 'Dutch VAT (distance sale, under the threshold)',
                distanceSaleDestination: 'Destination VAT (distance sale)',
                intraCommunitySupply: '0% intra-community supply',
                reviewRequired: 'Needs review',
                unsupported: 'Not supported',
            },
            treatment: {
                standard: 'standard',
                reduced: 'reduced',
                zeroRated: 'zero rated',
                exempt: 'exempt',
                intraCommunitySupply: 'intra community supply',
                outOfScope: 'out of scope',
            },
            reason: {
                merchantProfileMissing: 'No approved tax profile for the shop',
                distanceSalesModeUnconfirmed: 'Dutch or destination VAT for consumers abroad is not confirmed',
                noDestinationVatRegistration: 'No OSS or local VAT registration for the destination',
                viesInvalid: 'VAT number rejected by VIES',
                viesUnavailable: 'VIES could not be reached',
                viesNotChecked: 'VAT number not checked with VIES',
                vatIdCountryDiffers: 'VAT number is from another country than the delivery',
                sellerVatIdMissing: 'The shop has no Dutch VAT number in its profile',
                productNotClassified: 'Product not classified for VAT',
                noTaxRule: 'No VAT rule for the product in that country',
                overlappingTaxRules: 'Two VAT rules apply on the same day',
                discountExceedsEligible: 'Voucher larger than what it applies to',
                shippingAllocationUndefined: 'No goods to spread the shipping over',
                unsupportedDepartureCountry: 'Goods do not leave from NL',
                unsupportedDestinationCountry: 'Destination outside NL and BE',
                unsupportedLineKind: 'A line the engine does not handle',
            },
        },
        address: {
            shipTo: 'Ship to',
            billTo: 'Bill to',
            vat: 'VAT {number}',
        },
        notes: {
            title: 'Internal notes',
            help: 'Append-only audit log. Not visible to the customer.',
            placeholder: 'Add a note…',
            add: 'Add note',
            empty: 'No notes yet.',
            delete: 'Delete note',
            confirmDelete: 'Delete this note? This cannot be undone.',
            added: 'Note added',
            deleted: 'Note deleted',
        },
        timeline: {
            title: 'Payment timeline',
            help: 'Audit trail of the payment lifecycle, oldest first. Secrets are redacted.',
            empty: 'No payment events recorded.',
            details: 'Details',
            event: {
                orderPlaced: 'Order placed',
                gatewayStart: 'Gateway start',
                gatewayReturn: 'Gateway return',
                webhook: 'Webhook',
                markedPaid: 'Marked paid',
                acceptedUnpaid: 'Accepted, to be paid on delivery',
                markedCancelled: 'Marked cancelled',
                error: 'Error',
            },
        },
        emails: {
            title: 'Communication history',
            empty: 'No emails recorded for this order. Emails sent before 29 September 2026 were not recorded.',
            sent: 'Sent',
            to: 'To',
            by: 'By',
            attached: 'Attached: {files}',
            automatic: 'Automatic',
            statusSent: 'Sent',
            statusFailed: 'Failed',
            asSent: 'As sent',
            plainText: 'Plain text',
            noBody: 'Nothing was sent, so there is no body to show.',
            sentAgainTo: 'Sent again to {recipient}.',
            sendFailed: 'The email could not be sent.',
        },
        slip: {
            print: 'Print',
            withPrices: 'With prices',
            preview: 'Packing slip preview',
        },
        invoice: {
            invoiceNumber: 'Invoice {number}',
            creditNoteNumber: 'Credit note {number}',
            sentTo: 'sent to {to} {date}',
            notSent: 'not sent',
            create: 'Create invoice',
            send: 'Send invoice',
            sendCreditNote: 'Send credit note',
            creditNote: 'Create credit note',
            previewHelp: 'Preview below. Creating gives it the next number; it is emailed to {email} only when you send it.',
            preview: 'Invoice preview',
            confirmCreate: 'Give this invoice its number? An issued invoice cannot be changed. Nothing is emailed yet.',
            confirmSendInvoice: 'Email invoice {number} to {email}?',
            confirmSendCreditNote: 'Email credit note {number} to {email}?',
            confirmResendInvoice: 'Email invoice {number} to {email} again?',
            confirmResendCreditNote: 'Email credit note {number} to {email} again?',
            confirmCreditNote: 'Issue a credit note reversing invoice {number}? Nothing is emailed yet.',
            created: 'Invoice created',
            creditNoteCreated: 'Credit note created',
            sent: 'Invoice sent',
            sentAgain: 'Sent again',
            creditNoteSent: 'Credit note sent',
        },
    },
};
